var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.1152C27.4113 15.3722 26.7786 15.5459 26.1146 15.624C26.7924 15.2241 27.3129 14.5908 27.5579 13.8363C26.9136 14.2127 26.2086 14.4779 25.4735 14.6204C24.8747 13.9924 24.0216 13.6 23.0774 13.6C21.2646 13.6 19.7948 15.0468 19.7948 16.8313C19.7948 17.0846 19.8238 17.3312 19.8797 17.5677C17.1516 17.4329 14.7329 16.1465 13.1138 14.1915C12.8313 14.6687 12.6694 15.2239 12.6694 15.816C12.6694 16.9371 13.249 17.9261 14.1298 18.5056C13.6085 18.4895 13.0987 18.3509 12.6429 18.1014C12.6427 18.1149 12.6427 18.1285 12.6427 18.142C12.6427 19.7077 13.7742 21.0137 15.2758 21.3106C14.7924 21.44 14.2854 21.4589 13.7934 21.366C14.2111 22.6497 15.4234 23.5839 16.8598 23.6101C15.7364 24.4767 14.3209 24.9933 12.7831 24.9933C12.5181 24.9933 12.2568 24.978 12 24.9482C13.4527 25.865 15.1781 26.4 17.0319 26.4C23.0698 26.4 26.3715 21.4761 26.3715 17.206C26.3715 17.0659 26.3684 16.9265 26.362 16.7879C27.0046 16.3306 27.5593 15.7642 28 15.1152Z",
    fill: "#55ACEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCircle);
export default __webpack_public_path__ + "static/media/twitter-circle.35914c67a29953d523b63d1a8031ebd6.svg";
export { ForwardRef as ReactComponent };